import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicInstitution({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M4.25 6.25c.28 0 .5.22.5.5V11a.5.5 0 01-.07.25h2.64a.5.5 0 01-.07-.25V6.75c0-.28.22-.5.5-.5h.5c.28 0 .5.22.5.5V11a.5.5 0 01-.07.25h2.64a.5.5 0 01-.07-.25V6.75c0-.28.22-.5.5-.5h.5c.28 0 .5.22.5.5V11a.5.5 0 01-.07.25H14c.41 0 .75.34.75.75v1.75H15a.5.5 0 01.5.41v.59a.5.5 0 01-.5.5H1a.5.5 0 01-.5-.5v-.5c0-.28.22-.5.5-.5h.25V12c0-.38.28-.7.65-.74l.1-.01h1.32a.5.5 0 01-.07-.25V6.75c0-.28.22-.5.5-.5zm9 6.5H2.75v1h10.5v-1zM8.38.85l6 3.5c.66.39.39 1.4-.38 1.4H2c-.77 0-1.04-1.01-.38-1.4l6-3.5a.75.75 0 01.76 0zM8 2.37L4.77 4.25h6.46L8 2.37z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicInstitution.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicInstitution.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicInstitution svgRef={ref} {...props} />
));
export default ForwardRef;
